import React from "react";
import { Text, View } from "react-native";

import styles from "./integrationStyles";
import IntegrationDateTime from "./IntegrationDateTime";

export default function HealthIntegration({ data, showDate = false }) {
  const source = data?.source || {};
  const mediaText = data.name;

  return (
    <View>
      <Text style={styles.integrationName} numberOfLines={1} title={mediaText}>
        {mediaText}
      </Text>

      <View
        style={{
          display: "flex",
          alignItems: "center",
          flexDirection: "row",
        }}
      >
        <IntegrationDateTime source={source} showDate={showDate} />
      </View>
    </View>
  );
}
